import { Module } from '@nu-art/ts-common';
class ModuleFE_Provider_Class extends Module {
}
export const ModuleFE_Provider = new ModuleFE_Provider_Class();
//# sourceMappingURL=ModuleFE_Provider.js.map